import { IconName } from 'src/components/Icon';
import {
  modelIconsMap,
  newExternalModelsList,
  NINJA_AGENT_TEXT_AUTO_MODEL,
  NINJA_AGENT_TITLE,
  SUPER_AGENT_AS_EXTERNAL_MODEL,
} from 'src/constants';
import { UserSettingOption } from 'src/types/settings';
import type { ModelMetadata } from 'src/types/models/ModelMetadata';

// TODO(olha): expand function with others icons
export const getDefaultModelIconName = (
  modelId: string,
): IconName | undefined => {
  const provider = modelId.split('/')[1];

  switch (provider) {
    case 'bedrock':
      if (modelId.includes('nova-')) {
        return 'nova';
      }
      return 'awsLogo';

    case 'openai':
      return 'chatGPTLogo';

    case 'gemini':
      return 'googleGeminiProLogo';

    case 'ninja':
    case 'ninjatech':
      return 'ninjaOutlined';

    default:
      return undefined;
  }
};

export const prepareModelsList = (
  options: Record<string, UserSettingOption>,
  metadata: Record<string, ModelMetadata>,
) => {
  return Object.entries(options || {}).map(([keyOption, settingOption]) => {
    return {
      id: keyOption,
      iconName: getModelIcon({ targetModel: keyOption, metadata: metadata }),
      title: getModelDisplayName({
        targetModel: keyOption,
        metadata: metadata,
      }),
      availableIn: settingOption.requires,
      description: metadata[keyOption]?.description,
      isNew: Boolean(metadata[keyOption]?.data?.is_new),
    };
  });
};

interface GetModelDisplayNameParams {
  targetModel?: string | null;
  metadata?: Record<string, ModelMetadata>;
  defaultValue?: string;
}

export const getModelDisplayName = ({
  targetModel,
  metadata,
  defaultValue,
}: GetModelDisplayNameParams): string => {
  if (!targetModel) {
    return defaultValue || '';
  }
  return (
    (!!metadata && metadata[targetModel]?.display_name) ||
    newExternalModelsList[targetModel]?.display_name ||
    NINJA_AGENT_TITLE
  );
};

interface GetModelIconParams {
  targetModel?: string | null;
  metadata?: Record<string, ModelMetadata>;
  defaultValue?: IconName;
}

export const getModelIcon = ({
  targetModel,
  metadata,
  defaultValue,
}: GetModelIconParams): IconName | undefined => {
  if (!targetModel) {
    return defaultValue;
  }
  return (
    (!!metadata && modelIconsMap[metadata[targetModel]?.icon]) ||
    newExternalModelsList[targetModel]?.icon_name ||
    getDefaultModelIconName(targetModel)
  );
};

export const isExternalModel = (modelName?: string) => {
  if (!modelName) {
    return false;
  }
  return (
    modelName !== NINJA_AGENT_TEXT_AUTO_MODEL &&
    !modelName.includes(SUPER_AGENT_AS_EXTERNAL_MODEL)
  );
};

export const isExternalModelIcon = (iconName?: string) => {
  if (!iconName) {
    return false;
  }

  return !['ninjaMainIcon', 'ninjaPixProLogo'].includes(iconName);
};
